<template>
  <!-- 文章编辑页面 -->
  <div class="main">
    <div class="main_content">
      <div class="edit_left">
        <div class="edit_head">
          <p>文章标题</p>
          <el-input placeholder="请输入文章标题" v-model="queryInfo.newstitle" clearable>
          </el-input>
        </div>
        <quill-editor v-model="queryInfo.newscontent" ref="myQuillEditor" :options="editorOption">
        </quill-editor>
      </div>
      <div class="edit_right">
        <!-- 分类 -->
        <div v-show="this.options2.length > 0">
          <h3><i class="el-icon-s-flag"></i>分类:</h3>
          <el-select @change="handleChange1" placeholder="请选择" v-model="value1">
            <el-option
              v-for="item in options1"
              :key="item.itemid"
              :label="item.itemname"
              :value="item.itemid"
            >
            </el-option>
          </el-select>
          <el-select style="margin-left:8px" placeholder="请选择" v-model="value2">
            <el-option
              v-for="item in options2"
              :key="item.itemdetailid"
              :label="item.detailname"
              :value="item.itemdetailid"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 图片上传 -->
        <div class="uploadfile">
          <h3><i class="el-icon-upload"></i>上传图片</h3>
          <el-upload
            style="width:300px"
            :action="posturl"
            class="upload-demo"
            :limit="2"
            accept=".png,.jpg"
            :show-file-list="true"
            list-type="picture"
            :file-list="fileList"
            :headers="headers"
            :before-upload="beforeAvatarUpload"
            :on-remove="removeFile"
            :on-success="uploadSuccess"
          >
            <el-button size="small" type="primary" :disabled="fileurlList.length > 0"
              >点击上传</el-button
            >
            <p slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</p>
            <p slot="tip" class="el-upload__tip"><i class="el-icon-warning" style="color:#ff0000"></i>轮播图图片尺寸为：1400px*600px</p>
          </el-upload>
        </div>
        <!-- 简介 -->
        <div>
          <h3>文章简介</h3>
          <el-input type="textarea" maxlength="100" rows="4" v-model="queryInfo.introduction" @input="onIntroductionChange" placeholder="限100字"></el-input>
        </div>
        <div style="margin-top:16px">
          <h3>文章标签</h3>
          <el-input type="textarea" v-model="queryInfo.label" placeholder="多个标签用逗号隔开"></el-input>
        </div>
        <!-- 文章链接 -->
        <div style="margin-top:16px">
          <h3><i class="el-icon-link"></i>链接类型</h3>
        <el-switch
          v-model="queryInfo.isjump"
          style="margin-top:16px"
          :active-value="1"
          inactive-color="#ff4949"
          :inactive-value="0"
          active-text="有"
          inactive-text="无"
        ></el-switch>
        <p>
          <el-switch
            v-show="queryInfo.isjump === 1"
            v-model="hasoutlinkUrl"
            style="margin-top:16px"
            active-text="外部链接"
            inactive-color="#ff4949"
          ></el-switch>
        </p>
        <el-input
          v-show="queryInfo.isjump === 1 && hasoutlinkUrl"
          style="margin-top:16px"
          v-model="queryInfo.linkurl"
          placeholder="请输入外部链接"
        ></el-input>
        </div>
        
      </div>
    </div>
    <div style="text-align:center;margin-top:16px">
      <el-button type="primary" @click="publish">发布</el-button>
      <el-button @click="saveTemp">仅保存</el-button>
    </div>
  </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/ImageExtend', ImageExtend)
// use resize module
Quill.register('modules/ImageResize', ImageResize)

import api from '../../../api'
import base from '../../../api/base'

// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image'],
]
export default {
  created() {
    if (this.$route.query.newsid) {
      this.GetPortalNewsById(this.$route.query.newsid)
    }
    this.getTree1()
  },
  components: {
    quillEditor,
  },
  watch: {
    fileurlList: function() {
      if (this.fileurlList.length > 1) {
        this.queryInfo.imgurl = this.fileurlList.join(',')
      } else {
        this.queryInfo.imgurl = this.fileurlList[0]
      }
    },
    hasoutlinkUrl: function(value) {
      if (!value) {
        this.queryInfo.linkurl = ''
      }
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          imageDrop: true,
          ImageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize'],
          },
          ImageExtend: {
            loading: true,
            name: 'file',
            size: 2, // 单位为M, 1M = 1024KB
            action: base.qa + '/WebUploader/UplodeFile?isfenpian=false',
            headers: (xhr) => {
              xhr.setRequestHeader(
                'Authorization',
                'Bearer ' + window.localStorage.getItem('token')
              )
            },
            response: (res) => {
              console.log(res)
              return res.rows.url
            },
          },
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function() {
                QuillWatch.emit(this.quill.id)
              },
            },
          },
        },
      },
      queryInfo: {
        newsid: this.$route.query.newsid,
        isshowgateway: 0,
        newscontent: '',
        newstitle: '',
        author: '',
        imgurl: '',
        // 门户类型id
        portaltype: '',
        // 排序
        sort: '',
        isjump: 1,
        linkurl: '',
        introduction:'',
        label:''
      },
      hasoutlinkUrl: false,
      posturl: base.qa + '/WebUploader/UplodeFile?isfenpian=false',
      options1: [],
      options2: [],
      value1: '',
      value2: '',
      headers: {
        Authorization: 'Bearer ' + window.localStorage.getItem('token'),
      },
      fileurlList: [],
      fileList: [],
    }
  },
  methods: {
    // 获取文章详情
    async GetPortalNewsById(newsid) {
      const res = await api.baseNewsinfo.GetPortalNewsById({ newsid })
      if (!res.success) {
        this.$message.warning(res.msg)
      }
      this.hasoutlinkUrl = res.rows.linkurl && res.rows.linkurl.length > 0 ? true : false
      this.value1 = res.rows.moduleid
      this.value2 = res.rows.portaltype
      this.getTree2(this.value1)
      this.queryInfo = Object.assign({}, this.queryInfo, res.rows)
      if (this.queryInfo.imgurl.length > 0) {
        this.fileurlList = this.queryInfo.imgurl.split(',')
        this.fileList = this.fileurlList.map((item, i) => {
          return { name: `${i + 1}`, url: item }
        })
      }
    },
    async getTree1() {
      const { rows } = await api.dictionary.GetDataItemListByCode({ itemcode: 'PortalType' })
      this.options1 = rows
      if (!this.$route.query.newsid) {
        this.getTree2(rows[0].itemid)
      }
    },
    async getTree2(itemid) {
      const { rows } = await api.dictionary.GetDataItemDetailTreeList(itemid)
      this.options2 = rows
    },
    handleChange1(value) {
      this.getTree2(value)
      this.value2 = ''
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    //图片上传成功
    uploadSuccess(response, file, fileList) {
      if (!response.success) {
        this.$message.warning(response.msg)
      }
      this.fileurlList.push(response.rows.url)
    },
    // 移除文件
    removeFile(file) {
      console.log(file)
      this.fileurlList = this.fileurlList.filter((item, i) => {
        if (file.response) {
          return item != file.response.rows.url
        } else return item != file.url
      })
    },
    onIntroductionChange(value){
      if(this.queryInfo.introduction.length>100){
        this.$message.warning('字符超限')
      }
    },
    // 发布
    publish() {
      this.queryInfo.isshowgateway = 1
      this.save()
    },
    saveTemp() {
      this.queryInfo.isshowgateway = 0
      this.save()
    },
    // 保存
    async save() {
      this.queryInfo.author = this.$store.state.userInfo.username
      if (this.value2.length === 0) {
        return this.$message.warning('请选择文章分类')
      }
      if (this.hasoutlinkUrl && this.queryInfo.linkurl.trim() === '') {
        return this.$message.warning('请输入外部链接！')
      }
      console.log(this.queryInfo);
      // 处理标签
      if(this.queryInfo.label){
        this.queryInfo.label=this.queryInfo.label.replaceAll('，',',')
      }
      this.queryInfo.portaltype = this.value2
      const res = await api.baseNewsinfo.SaveData(this.queryInfo)
      if (!res.success) return this.$message.warning(res.msg)
      this.$message.success(res.msg)
      if (this.$route.query.newsid) {
        setTimeout(() => {
          location.reload()
        }, 1500)
      } else {
        setTimeout(() => {
          this.$router.push('/door/article/list')
        }, 1500)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.main {
  background-color: #fff;
  padding: 20px;
  h3 {
    margin-bottom: 8px;
  }
  .main_content {
    display: flex;
    justify-content: space-between;
    /deep/.quill-editor {
      margin-top: 16px;
      .ql-container {
        max-width: 1077px;
        min-height: 600px;
        .ql-snow {
          .ql-editor {
            img {
              width: 300px;
            }
          }
        }
      }
    }
    .edit_head {
      display: flex;
      align-items: center;
      p {
        flex: 1 0 90px;
        font-weight: bold;
        font-size: 18px;
      }
      /deep/ .el-input {
        input {
          font-weight: bold;
        }
      }
    }
    .edit_right {
      flex: 1;
      margin-left: 24px;
      padding-left: 24px;
      border-left: 1px solid #eee;
      .uploadfile {
        margin: 16px 0;
        h3 {
          margin: 16px 0;
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            margin: 8px;
          }
          img {
            width: 300px;
          }
        }
      }
    }
  }
}
</style>
